export default {
    ownerAccount: `Owner Account`,
    updateAccount: 'Update Account',
    updateProfile: `Update Profile`,
    locations: `Locations`,
    changePassword: `Change Password`,
    logout: `Logout`
}